export const BDC_ADDRESS_TOTAL_FORMAT_ERROR =
  "La dirección completa (calle y números) no puede exceder 80 caracteres.";

/** Normalization used by the BDC identity and company payload projections. */
export function normalizeBdcName(value: string): string {
  return value
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/** Join the normalized street and number fields exactly as sent to SIC. */
export function getBdcStreetAddressProjection(
  values: Readonly<Record<string, unknown>>,
  fieldKeys: readonly string[],
): string {
  return fieldKeys
    .map((key) => normalizeBdcName(String(values[key] ?? "")))
    .filter(Boolean)
    .join(" ");
}
